export default "__VITE_ASSET__k3E7Ig8E__"